import React from 'react';
import './style.css';

const Heading = () => (
  <span className='h2'>Eligibility & Contribution Rules</span>
);

export default React.memo(Heading);
